// JsFromRoutes CacheKey 2597bd61f984fd44ead77074bb75ce2f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/:account_id/contacts'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/contacts'),
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/contacts/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/contacts/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/contacts/:id'),
}
